import moment from 'moment';
import jwt_decode from "jwt-decode";
import {bindActionCreators} from 'redux';

import {unauthorized} from './application.actions';

const url = process.env.REACT_APP_API_URL;
const authorizedRoles = ['ePASRR_Administrator', 'ePASRR_NursingFacility', 'ePASRR_HSAG', 'ePASRR_MQD'];
let lastTokenRefreshDate = moment();

const tokenKey = 'compliance_token';
export const getToken = () => localStorage.getItem(tokenKey);
export const setToken = token => localStorage.setItem(tokenKey, token);
export const removeToken = () => localStorage.removeItem(tokenKey);
export const decodeToken = () => {
  try {
    const token = jwt_decode(getToken()) || {};
    return Array.isArray(token.role) ? token : {...token, role: []}
  } catch (e) {
    return {role: []}
  }
};

export const isValidToken = () => {
  const token = decodeToken();

  const validLifetime = token.exp >= (Date.now() / 1000);
  const requiredRole = authorizedRoles.some(ar => token.role.includes(ar));

  return validLifetime && requiredRole;
};

export const refreshToken = async (dispatch) => {

  const token = getToken();
  const tokenData = decodeToken(token);
  const actions = bindActionCreators({unauthorized}, dispatch);

  const validLifetime = () => tokenData.exp >= ((Date.now() / 1000));

  const shouldRefreshToken = () => {
    if (!validLifetime())
      return false;
    const minutesSinceLastRefresh = moment.duration(moment().diff(lastTokenRefreshDate)).as('minutes');
    console.log(`last refresh was ${minutesSinceLastRefresh.toFixed(2)} minutes ago.`);
    return minutesSinceLastRefresh > 1;
  };

  if (shouldRefreshToken()) {
    await fetch(`${url}/epasrr/token?token=${getToken()}`, {
      headers: {
        'Authorization': token,
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      }
    })
      .then(res => {
        if (res.status === 401) {
          return dispatch(actions.unauthorized());
        }
        return res.json()
      })
      .then(({token}) => {
        console.log('refreshed authorization token');
        lastTokenRefreshDate = moment();
        setToken(token);
      })
  } else {
    await Promise.resolve();
  }
};



// WEBPACK FOOTER //
// ./src/token_management.js